/* global dataLayer */

function init(productDownloadsEl) {
    if (!productDownloadsEl) productDownloadsEl = document.getElementById('productdownloads');
    const dopDownload = productDownloadsEl.querySelector('a[target="_blank"]');
    if (dopDownload) {
        dopDownload.addEventListener('click', function () {
            logActivity('DOP');
        });
    }

    const dopDownloadButton = productDownloadsEl.querySelector('#hlDownloadPds');

    if (dopDownloadButton) {
        dopDownloadButton.addEventListener('click', function () {
            logActivity('PDS_OPEN_MODAL');
        });
    }
}

function initMediaFile(mediaFileDownloadsEl) {
    if (!mediaFileDownloadsEl) mediaFileDownloadsEl = document.getElementById('mediafiledownload');

    const mediaDownloadButton = mediaFileDownloadsEl.querySelector('#hlDownloadMediaFile');
    if (mediaDownloadButton) {
        mediaDownloadButton.addEventListener('click', function () {
            logActivity('MEDIAFILE_OPEN_MODAL');
        });
    }
}

function logActivityIfElIsPresent(elId) {
    if (elId) {
        const el = document.getElementById(elId);
        if (el) {
            var downloadType = el.value;
            logActivity(downloadType);
        }
    }
}

function logActivity(downloadType) {
    dataLayer.push({
        'event': 'DownloadRequest',
        'detail': {
            'ActivityCodeName': `DownloadRequest_${downloadType}`,
            'ActivityTitle': 'Download request',
            'ActivityValue': downloadType
        }
    });
}

function provideGlobal() {
    if (!window.FRDownloadRequestActivityLogger) {
        window.FRDownloadRequestActivityLogger = logActivityIfElIsPresent;
    }
}

export default {
    init,
    initMediaFile,
    provideGlobal
};
